import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import { IoMdBulb, IoMdEye, IoMdRocket } from 'react-icons/io';


import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';

export default function AboutUsContent(props) {

	const appContext = useContext(AppContext);

	const infoCards = [
		{
		icon: <IoMdEye size={48} className="text-primary" />,
		title: 'OUR VISION',
		description: 'To become a leading construction company recognized for excellence, innovation, and sustainable development across the region.'
		},
		{
		icon: <IoMdRocket size={48} className="text-primary" />,
		title: 'OUR MISSION',
		description: 'To deliver high-quality construction and engineering solutions through professional expertise, advanced technologies, and a commitment to safety, environmental responsibility, and client satisfaction.'
		}
	];

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					paddingBottom: "50px",
				}}
			>
				<div className="container">
					<div className="row py-3">

						<div className="col-md-6 p-3">
							<div 
								className="rounded d-flex justify-content-center align-items-center"
								style={{
									overflow: "hidden",
									width: "100%",
								}}
							>
									<img src={banner1} style={{width: "100%"}}/>
							</div>
						</div>

						<div className="col-md-6 py-3">
							<h4 className="text-muted font-semi-bold">About Us</h4>
							<h3 className="text-secondary font-bold">Jenga Construction Ltd</h3>
							<h6 className="font-semi-bold">
								Jenga Construction Ltd was officially registered with the Government of Tanzania through the Registrar of Companies and a reputable and fast-growing construction company committed to delivering high-quality building and civil engineering solutions. 
								<br/><br/>
								Established with the aim of providing reliable and sustainable services, the company has developed a strong footprint in the industry through professionalism, innovation, and consistent project delivery.
								<br/><br/>
								Our expertise covers commercial and residential construction, structural rehabilitation, infrastructure development, and routine maintenance works.
								<br/><br/>
								With a skilled workforce and modern equipment, Jenga Construction Ltd delivers projects with precision, safety, and efficiency while maintaining the highest standards of client satisfaction.
							</h6>
							
						</div>

						
					</div>
					<div className="d-flex gap-1 align-item-center justify-content-center mt-3">
						<div className="bg-secondary py-3 px-3 text-center">
							<h3 className="px-3">FOUNDED</h3>
							<hr/>
							<h6>August 29<sup>th</sup>, 2007</h6>
						</div>

						<div className="bg-secondary py-3 px-5 text-center">
							<h3 className="px-3">ACT</h3>
							<hr/>
							<h6>2002</h6>
						</div>
					</div>
							

					<div className="row g-4 justify-content-center p-4">
						<div className="col-md-12 text-center">
							<h1 className="main-section-title">Mision & Vision </h1>
							<h6>
								Our organization operates with a clear purpose and a deliberate view of the future. The following statements outline our commitment and aspirations.
							</h6>
						</div>
						{infoCards.map((card, index) => (
							<div key={index} className="col-md-4 d-flex justify-content-center">
								<div className="rounded-4 shadow-lg p-4 bg-white text-center" style={{ maxWidth: '380px' }}>
									<div className="rounded-circle mx-auto mb-3 bg-light d-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
										{card.icon}
									</div>
									<div className="bg-light rounded-4 p-3">
										<h5 className="fw-bold mb-2">{card.title}</h5>
										<p className="mb-3" style={{ fontSize: '0.9rem' }}>{card.description}</p>
									</div>
								</div>
							</div>
						))}

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}